export default {
    MUTATE_SAVE_PAGE(state, payload) {
        state.savedPage = payload;
    },
    saveSavedContent(state, data) {
        state.savedContent = data
    },
}

